import { NO_RESULTS } from './noResultsConstants';

export const noResultsTemplate = (state = '', action) => {
  switch (action.type) {
    case NO_RESULTS:
      return action.template;
    default:
      return state;
  }
};
